import { FlexBox, FlexBoxFullWidth } from './boxes';
import { Box, MenuItem, TextField } from '@mui/material';
import { TEXTS } from '../../core/texts';
import { ValidationErrorState } from '../../types/validationErrorState';
import { ChangeEvent } from 'react';
import { Validator } from '../../core/Validator';
import { TimezoneAutocomplete } from './TimezoneAutocomplete';

const hoursArr = Array(24).fill(null).map((_, h) => h);

interface Props {
  fromHour: number,
  toHour: number,
  timezone: string,
  validationErrors: ValidationErrorState,
  handleInputChange: (e: ChangeEvent<HTMLInputElement>) => void,
  disabled: boolean
}

const TimeSelectAndTimezone = ({
                                 fromHour,
                                 toHour,
                                 validationErrors,
                                 handleInputChange,
                                 timezone,
                                 disabled
                               }: Props) => {
  
  return (
    <FlexBoxFullWidth my={4} flexDirection={{ mobile: 'column', laptop: 'row' }}>
      <FlexBox width={{ mobile: '100%', laptop: '50%' }} mb={{ mobile: 4, laptop: 0 }}>
        <TextField name={'fromHour'}
                   label={TEXTS.FROM_HOUR}
                   value={fromHour}
                   onChange={handleInputChange}
                   required={!disabled && !!Validator.LENGTHS.AVAILABILITY['fromHour']?.min}
                   error={!!validationErrors['fromHour']}
                   helperText={validationErrors['fromHour']}
                   select={true}
                   fullWidth
                   disabled={disabled}
                   sx={{ mr: 2 }}
                   variant={disabled ? 'standard' : 'outlined'}
                   SelectProps={{ MenuProps: { sx: { maxHeight: { mobile: 200, tablet: 300 } } } }}
        >
          {
            hoursArr.map((h) => (
              <MenuItem key={h} value={h} sx={{ maxHeight: 100 }}>
                {`${h}:00`}
              </MenuItem>
            ))
          }
        </TextField>
        <TextField name={'toHour'} label={TEXTS.TO_HOUR}
                   value={toHour}
                   onChange={handleInputChange}
                   required={!disabled && !!Validator.LENGTHS.AVAILABILITY['toHour']?.min}
                   error={!!validationErrors['toHour']}
                   helperText={validationErrors['toHour']}
                   select={true}
                   disabled={disabled}
                   SelectProps={{ MenuProps: { sx: { maxHeight: { mobile: 200, tablet: 300 } } } }}
                   fullWidth
                   variant={disabled ? 'standard' : 'outlined'}
        >
          {
            hoursArr.map((h) => (
              <MenuItem key={h} value={h} defaultValue={0}>
                {`${h}:00`}
              </MenuItem>
            ))
          }
        </TextField>
      </FlexBox>
      <Box ml={{ mobile: 0, laptop: 2 }} width={'100%'}>
        <TimezoneAutocomplete
          value={timezone} variant={disabled ? 'standard' : 'outlined'} disabled={disabled}
          handleInputChange={handleInputChange}
        />
      </Box>
      
    </FlexBoxFullWidth>

  );
};

export default TimeSelectAndTimezone;